import { render, staticRenderFns } from "./23qidongshipin.vue?vue&type=template&id=806ca002&"
import script from "./23qidongshipin.vue?vue&type=script&lang=js&"
export * from "./23qidongshipin.vue?vue&type=script&lang=js&"
import style0 from "./23qidongshipin.vue?vue&type=style&index=0&id=806ca002&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports